import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import request from "../../../../network/request";
import {
  IenvirInspectionSheetDetail,
  ConditionInfoList,
  AddInfo
} from "../../types";
import useQuery from "../../../../hooks/useQuery";

import styles from "./index.module.scss";

import useGetCh from "../../../../hooks/useGetCh";
import { reportUserBehavior } from "../../../../utils/common";
import LoadingHomepage from "../../../maintence/components/LoadingHomepage";
import { ErrorPlaceholder } from "../../../../components/placeholder";
import moment from "moment";

export default function EnvirInspectionSheetDetail() {
  document.title = "环车检查";
  const ch = useGetCh();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [orderDetail, setOrderDetail] =
    useState<IenvirInspectionSheetDetail | null>(null);
  const [fileList, setFileList] = useState<Array<string>>([]);
  const [conditionInfoList, setConditionInfoList] = useState<
    Array<ConditionInfoList>
  >([]);
  const [addInfoList, setAddInfoList] = useState<Array<AddInfo>>([]);
  const [addInfoImg, setAddInfoImg] = useState<Array<any>>([]);
  const [attachmentList, setAttachmentList] = useState<Array<any>>([]);
  const [showCarInfo, setShowCarInfo] = useState<Boolean>(false);
  const query = useQuery();
  const history = useHistory();
  // 获取路由query参数
  const aroundCheckOrderNo = query.get("aroundCheckOrderNo");

  // 初始化请求
  useEffect(() => {
    getInitData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAutograph = () => {
    reportUserBehavior(
      {
        so: "J001002",
        mcode: "envir_inspection_sheet_detail_to_sign",
        ch,
        pa: `aroundCheckOrderNo=${aroundCheckOrderNo}`
      },
      "event"
    );
    history.push(
      `/serviceOrders/signatureAgreement?aroundCheckOrderNo=${aroundCheckOrderNo}`
    );
  };

  const getInitData = async () => {
    setLoading(true);
    setError(false);
    await getEnvirInspectionSheetDetail();
    setLoading(false);
  };
  const reloadData = async () => {
    await getInitData();
  };

  const getEnvirInspectionSheetDetail = async () => {
    let imgList: any = [];
    try {
      const data: any = await request(
        "serviceOrder/getAroundCheckOrderDetail",
        { aroundCheckOrder: aroundCheckOrderNo },
        "POST"
      );

      if (JSON.stringify(data) !== "{}") {
        setConditionInfoList(data.conditionInfoList);

        const addInfoList = data.addInfoList || [];
        addInfoList.forEach((item) => {
          item.attachment.split(",").forEach((file) => {
            imgList.push(file.split("|")[1]);
          });
        });
        setAddInfoImg(addInfoList);

        data.conditionInfoList.forEach((item) => {
          item.damageStr = "";
          item.damageLevel.split(",").forEach((v) => {
            switch (v) {
              case "1":
                item.damageStr += "凹凸;";
                break;
              case "2":
                item.damageStr += "划痕;";
                break;
              case "3":
                item.damageStr += "损坏;";
                break;
              case "4":
                item.damageStr += "破损;";
                break;
              case "5":
                item.damageStr += "污渍;";
                break;
            }
          });
          item.attachment.split(",").forEach((v) => {
            imgList.push(v.split("|")[1]);
          });
        });

        data.attachment &&
          data.attachment.split(",").forEach((item) => {
            imgList.push(item.split("|")[1]);
          });
        let tempAttachment = [];
        tempAttachment =
          data.attachment &&
          data.attachment.split(",").map((v) => {
            return {
              name: v.split("|")[0],
              url: v.split("|")[1]
            };
          });
        setAttachmentList(tempAttachment);

        let tempList = duplicateRemoval(addInfoList);
        setAddInfoList(tempList);
        setOrderDetail(data);
        setFileList(imgList);

        // 车辆信息
        const tempCarList =
          data?.withCarItemList !== "" || addInfoList.length > 0;
        setShowCarInfo(tempCarList);
      }
      window.scrollTo(0, 0);
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "order_detail",
          ch,
          pa: `status=success`
        },
        "page"
      );
    } catch (err) {
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "order_detail",
          ch,
          pa: `status=error`
        },
        "page"
      );
      setError(true);
      setErrorMsg((err as any).message || "加载数据失败，请稍后重试");
    }
  };

  const damageDetail = (item) => {
    let conditionInfo: any = {};
    let addInfo: any = {};
    let attachmentObj: any = {};
    conditionInfo =
      conditionInfoList &&
      conditionInfoList.find((v: any) => {
        return v.attachment.indexOf(item) > -1;
      });
    addInfo =
      addInfoImg &&
      addInfoImg.find((v: any) => {
        return v.attachment.indexOf(item) > -1;
      });
    attachmentObj =
      attachmentList &&
      attachmentList.find((v) => {
        return v.url.indexOf(item) > -1;
      });

    if (conditionInfo) {
      conditionInfo.type = "1";
      conditionInfo.diagnose =
        orderDetail?.seFaultDiagnosisListResp?.diagnosisSituation;
      conditionInfo.url = item;
      // 第二个参数传递数据
      history.push(`/serviceOrders/orderDetail/detailsAppearanceDamage`, conditionInfo);
    }
    if (addInfo) {
      addInfo.type = "2";
      addInfo.url = item;
      history.push(`/serviceOrders/orderDetail/detailsAppearanceDamage`, addInfo);
    }
    if (attachmentObj) {
      attachmentObj.type = "3";
      history.push(`/serviceOrders/orderDetail/detailsAppearanceDamage`, attachmentObj);
    }
  };

  const duplicateRemoval = (arr) => {
    let result = arr.reduce((pre, acc) => {
      let obj = pre.find((v) => v.content === acc.content);
      let _d = {
        ...acc,
        count: 1
      };
      obj ? obj.count++ : pre.push(_d);
      return pre;
    }, []);
    return result;
  };

  // 环境单信息
  const information = (
    <div>
      <p className={styles.title}>环检单信息</p>
      <div className={styles.message}>
        <span className={styles.messageLeft}>环检单号</span>
        <span className={styles.messageRight}>{orderDetail?.orderNo}</span>
      </div>
      <div className={styles.message}>
        <span className={styles.messageLeft}>环检时间</span>
        <span className={styles.messageRight}>
          {moment(orderDetail?.checkTime).format("YYYY/MM/DD HH:mm")}
        </span>
      </div>
      <div className={styles.message}>
        <span className={styles.messageLeft}>服务门店</span>
        <span className={styles.messageRight}>{orderDetail?.shopName}</span>
      </div>
      <div className={styles.message}>
        <span className={styles.messageLeft}>服务管家</span>
        <span className={styles.messageRight}>{orderDetail?.saName}</span>
      </div>
      <div className={styles.message}>
        <span className={styles.messageLeft}>服务管家电话</span>
        <a href={`tel:${orderDetail?.saMobile}`} className={styles.phone}>
          {orderDetail?.saMobile}
        </a>
      </div>
    </div>
  );

  // 车辆信息
  const vehicleInformation = showCarInfo ? (
    <div className={styles.vehicle}>
      <h2 className={styles.title}>车辆信息</h2>
      {orderDetail?.withCarItemList !== "" && (
        <div className={styles.message}>
          <span className={styles.messageLeft}>随车物品</span>
          <span className={styles.messageRight}>
            {orderDetail?.withCarItemList &&
              orderDetail?.withCarItemList.split(",").join(";")}
          </span>
        </div>
      )}
      {addInfoList.length > 0 && (
        <div className={styles.message}>
          <span className={styles.messageLeft}>加改装信息</span>
          <span className={styles.messageRight}>
            {addInfoList.map((item) => {
              return item.content + "×" + item.count + ";";
            })}
          </span>
        </div>
      )}
    </div>
  ) : null;

  // 车辆情况
  const vehicleCondition = fileList?.length ? (
    <div className={styles.vehicle}>
      <p className={styles.title}>车辆情况</p>
      <div className={styles.imgList}>
        {fileList.map((item, index) => {
          return item ? (
            // src={item + "?param=300×300"}
            <div className={styles.gridItem} key={index}>
              <img
                src={item}
                alt=""
                className={styles.img}
                onClick={() => {
                  damageDetail(item);
                }}
              />
            </div>
          ) : null;
        })}
      </div>
    </div>
  ) : null;

  // 损伤情况
  const damageCondition =
    conditionInfoList.length > 0 ? (
      <div className={styles.damage}>
        <p className={styles.title}>损伤情况</p>
        <div className={styles.damageList}>
          {conditionInfoList.map((item, index) => {
            return (
              <div className={styles.damageContent} key={index}>
                <div className={styles.damagePart}>
                  {item.part}：{item.damageStr}
                </div>
                <div className={styles.damageRemark}>{item.remark}</div>
              </div>
            );
          })}
        </div>
      </div>
    ) : null;

  // 诊断结果
  const diagnosticResults = orderDetail?.seFaultDiagnosisListResp
    ?.diagnosisSituation ? (
    <div className={styles.vehicle}>
      <p className={styles.title}>诊断结果</p>
      <div className={styles.remarks}>
        {orderDetail?.seFaultDiagnosisListResp.diagnosisSituation}
      </div>
    </div>
  ) : null;

  // 签名提示
  const signTips = (
    <div className={styles.signTips}>
      本人遵守《小鹏售后服务协议》服务条款，已确认登记无误，同意贵公司维修上述项目，并同意维修必要的厂外试车，本人亦认可维修必要的辅料按实际消耗量进行结算，并同意承担全部费用。本人确认无贵重物品。
    </div>
  );

  // 签名
  const autograph =
    orderDetail?.signStatus === 1 ? (
      <div className={styles.wrapper}>
        <div className={styles.autograph} onClick={handleAutograph}>
          <button className={styles.autographBtn}>去签名</button>
        </div>
      </div>
    ) : orderDetail?.signStatus === 2 ||
      orderDetail?.signStatus === 3 ||
      orderDetail?.signStatus === 4 ? (
      <div className={styles.wrapper}>
        <div className={styles.signed}>
          <button className={styles.signedBtn}>已签名</button>
        </div>
      </div>
    ) : null;

  if (loading) {
    return <LoadingHomepage></LoadingHomepage>;
  }

  if (error) {
    reportUserBehavior(
      {
        so: "J001002",
        mcode: "maintence",
        ch,
        pa: `status=error`
      },
      "page"
    );
    return (
      <ErrorPlaceholder
        message={errorMsg}
        getData={reloadData}
      ></ErrorPlaceholder>
    );
  }

  return (
    <div className={styles.sheetBox}>
      <div className={styles.detailPageWrapper}>
        {information}
        {vehicleInformation}
        {damageCondition}
        {vehicleCondition}
        {diagnosticResults}
        {signTips}
      </div>
      <div className={styles.footer}>{autograph}</div>
    </div>
  );
}
